module.exports = __webpack_public_path__ + "img/img-fachai-fish-d.1aeff0a8.png";